import { UserRole } from '@core-lib/enums';
import { ICurrencyMaskOptions, IDatagridOptions } from '@core-lib/models';
import { IConfig as NgxMaskConfig } from 'ngx-mask';
import { MatDateFormats } from '@angular/material/core';

export class AppConstants {
	// Local storage
	static LOCALSTORAGE_KEYS = {
		appLanguage: 'app-language',
		accessToken: 'access-token',
		refreshToken: 'refresh-token',
		idpServiceIndex: 'idp-service-index',
		idpKind: 'idp-kind',
		tenantKey: 'tenant-key',
		authMode: 'auth-mode',
		oidcMode: 'oidc-mode',
		deviseReference: 'deviseReference'
	};

	// Session storage
	static SESSIONSTORAGE_KEYS = {
		avocatCurrentCompte: 'avocat-current-compte'
	};

	static AuthScheme = {
		Bearer: 'Bearer'
	};

	// User
	static DEFAULT_USER_ROLE: UserRole = UserRole.AVOCAT;

	// File weight
	static KILOBYTE: number = 1024;
	static MEGABYTE: number = AppConstants.KILOBYTE * 1000;
	static GIGABYTE: number = AppConstants.MEGABYTE * 1000;

	// Regex
	static LIBELLE_CONTRAINT_EXPRESSION = '^[^&<>]*$';

	// Time
	static MILLISECONDS: number = 1000;
	static SECOND: number = 1 * AppConstants.MILLISECONDS;
	static MINUTE: number = 60 * AppConstants.SECOND;
	static HOUR: number = 60 * AppConstants.MINUTE;

	// Datagrid
	static DATAGRID_OPTIONS_DEFAULTS: IDatagridOptions = {
		orginalPageSize: 15,
		availablePageSizes: [15, 30, 50, 100],
		hasSort: true,
		hasPaging: true,
		hasPageSize: true
	};

	// Datagrid tableau opération
	static DATAGRID_VALIDATION_OPTIONS: IDatagridOptions = {
		orginalPageSize: 15,
		availablePageSizes: [15, 30, 50, 100, 200],
		hasSort: true,
		hasPaging: true,
		hasPageSize: true
	};

	static DATE_TIME_FORMATS: MatDateFormats = {
		parse: {
			dateInput: 'DD/MM/YYYY HH:mm',
			timeInput: 'HH:mm'
		},
		display: {
			dateInput: 'DD/MM/YYYY HH:mm',
			monthYearLabel: 'monthYearLabel',
			dateA11yLabel: 'dd/MM/yyyy',
			monthYearA11yLabel: 'monthYearLabel',

			timeInput: 'HH:mm',
			timeOptionLabel: 'HH:mm'
		},
	}
	// Input Masks
	static CURRENCY_MASK_OPTIONS: ICurrencyMaskOptions = {
		align: 'left',
		allowNegative: false,
		allowZero: false,
		decimal: ',',
		precision: 2,
		prefix: '',
		suffix: '',
		thousands: ' ',
		nullable: true,
		inputMode: 'Natural'
	};

	static INPUT_MASKS: { [key: string]: string } = {
		amount: 'separator.2'
	};

	static NGX_MASK_OPTIONS: Partial<NgxMaskConfig> = {
		thousandSeparator: ' ',
		decimalMarker: ','
	};

	// Regex
	static REGEX = {
		startAlpha: /[^a-zA-Z]/g,
		startNumeric: /[^0-9]/g,
		specialChars: /[^\w\s]/gi,
		specialCharsWithAccentsAllowed: /[^\w\sÀ-ÿ]/gi,
		unicodeSpecialChars: /[^\p{L}\d\s]/gu,
		symbolChars: /[<>&?!,.;:"'#²~=/|*+_]/g,
		symbolCharsWithApostrophe: /[<>&?!,.;:"#²~=/|*+_]/g,
		numericChars: /[0-9]{1,}/,
		alpha: /^[a-zA-ZÀ-ú]*$/,
		numeric: /^[0-9]*$/,
		nonNumeric: /\D/g,
		numericNegative: /^[-]?[0-9]*$/,
		numericWithoutDotNegative: /^-?[0-9]{1,}([0-9]{0,2})?$/,
		numericWithoutDot: /^[0-9]{1,}([0-9]{0,2})?$/,
		alphanumeric: /^[a-zA-Z0-9]*$/,
		alphanumericiban: /^[a-zA-Z0-9_ ]*[a-zA-Z0-9]$/,
		decimal: /^[0-9]{1,}([\\.,][0-9]{0,2})?$/,
		decimalNegative: /^-?[0-9]{1,}([\\.,][0-9]{0,2})?$/,
		intPositiveOrNegative: /^-?[0-9]*$/,
		telephone: /^[0-9 +.()-]*$/,
		nomEmetteur: /^[^&<>]*$/,
		nomContactEcarpa: /[^a-zA-ZÀ-ÿ.,\-_ ]+/g,
		numericWithwhiteSpace: /[0-9 ]+/,
		datePicker: /^[\d/]+$/,
		filterNomEmetteur: /[&<>]/g,
		letterAndApostropheFilter: /[^\p{L}\d'\s]+/gu,
		removeWhitespace: /\s/g,
		datePickerRangeDateValidator: /^$|^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/,
		basicEmailValidation:
			//https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#basic_validation
			/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
	};

	// Saisie affaire

	static SAISIE_AFFAIRE_KEYS = {
		depotForm: 'depotForm',
		ribForm: 'ribForm',
		retraitForm: 'retraitForm'
	};

	static overrideWith(newValues: AppConstants): void {
		Object.assign(AppConstants, newValues);
	}

	static setAmountMaskDecimals(decimals: number): void {
		AppConstants.INPUT_MASKS.amount = `separator.${decimals}`;
		AppConstants.CURRENCY_MASK_OPTIONS.precision = decimals;
	}

	static MAX_LENGHT_NOM_EMETTEUR_RETRAIT = 30;
	static MAX_LENGHT_NOM_EMETTEUR = 100;

	// Qualite tiers comportement value
	static AVOCAT_ADVERSE_COMPORTEMENT_PREFIX_VALUE = 'CARPA';
	static TRESOR_PUBLIC_COMPORTEMENT_VALUE = 'TRESOR PUBLIC';

	// Pays code ISO
	static FRANCE_CODE_ISO = 'FR';

	// Devise code ISO
	static EURO_CODE_ISO = 'EUR';

	// Limitations
	static INTEGER_LIMIT_MAX = 2147483647;
}
